// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__3Hcq2","form":"styles_form__3OY3I"};